export const ARCHON_ROOT = '/archon';
export const ARCHON_TASKS_COSTS_PATH = `${ARCHON_ROOT}/tasks-costs`;
/** The plain-language explanation of the Tasks & Costs projection, with the live figures. */
export const ARCHON_HOW_THE_ESTIMATE_WORKS_PATH = `${ARCHON_TASKS_COSTS_PATH}/how-it-works`;
export const ARCHON_ACCURACY_PATH = `${ARCHON_ROOT}/accuracy`;
/** Each vendor labeler's quizzes and Match tasks, against their vendor's peers. */
export const ARCHON_LABELERS_PATH = `${ARCHON_ROOT}/labelers`;
/** One store as a dashboard: its Task flow, its cameras' repeat work and live templates. */
export const ARCHON_PER_STORE_PATH = `${ARCHON_ROOT}/per-store`;
export const ARCHON_MATCH_TRACE_PATH = `${ARCHON_ROOT}/match-trace`;
export const ARCHON_DATA_ROLLOUT_PATH = `${ARCHON_ROOT}/data/rollout-schedules`;
export const ARCHON_DATA_INVOICES_PATH = `${ARCHON_ROOT}/data/invoices`;
export const ARCHON_DATA_COST_MODEL_PATH = `${ARCHON_ROOT}/data/cost-model`;
export const ARCHON_DATA_INGRESS_SOURCES_PATH = `${ARCHON_ROOT}/data/ingress-sources`;
export const ARCHON_DATA_QA_SAMPLING_PATH = `${ARCHON_ROOT}/data/qa-sampling`;
/** Kit showcase: reachable by URL, deliberately out of the navigation. */
export const ARCHON_KIT_PATH = `${ARCHON_ROOT}/kit`;
